
import React from 'react';
import { DocumentType, PricingTableFormValues } from '@/models';
import { PricingTableRegularFees } from './PricingTableRegularFees';
import { PricingTableBundles } from './PricingTableBundles';


interface PricingTableDocumentFeesProps {
  feesApportionParties: any[];
  documentTypes: DocumentType[];
}

export const PricingTableDocumentFees: React.FC<PricingTableDocumentFeesProps> = ({
  feesApportionParties,
  documentTypes
}) => {
  return (
    <div className="space-y-6">
      <PricingTableRegularFees 
        feesApportionParties={feesApportionParties}
        documentTypes={documentTypes}
      />
      <PricingTableBundles 
        feesApportionParties={feesApportionParties}
        documentTypes={documentTypes}
      />
    </div>
  );
};
